import {JsonApiService} from '@/modules/claims/services/api'

class TagApi extends JsonApiService {
  constructor () {
    super('tag')
  }
}

export {TagApi}
